import {DataStatus} from 'platform/components';

import {useParams} from 'react-router-dom';

import {useGetChecklistDefinitionQuery, useUpdateChecklistDefinitionMutation} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';
import {handleApiError} from '@dms/shared';

import {ApiError, useNavigate} from 'shared/web';

import {ChecklistForm} from '../../components/ChecklistForm';

export function Detail() {
  const {id: checklistId} = useParams();
  const navigate = useNavigate();

  const checklistDetailQuery = useGetChecklistDefinitionQuery(
    {definitionId: checklistId || ''},
    {skip: !checklistId}
  );

  const [updateChecklistDefinition, updateChecklistDefinitionQuery] =
    useUpdateChecklistDefinitionMutation();

  return (
    <DataStatus isLoading={checklistDetailQuery.isLoading} isError={checklistDetailQuery.isError}>
      <SettingsTemplate
        header={{
          title: checklistDetailQuery.data?.name || '',
          breadcrumbs: [
            {
              label: i18n.t('page.generalSettings.labels.title'),
              isCurrentPage: true,
            },
            {
              label: i18n.t('page.settings.generalChecklist.title'),
              href: settingsRoutes.generalChecklist,
            },
          ],
        }}
        data-testid={testIds.settings.generalChecklistDetail()}
      >
        <ChecklistForm
          defaultValues={checklistDetailQuery.data}
          onSubmit={async (formData, _setErrors, _reset, blockerContext) => {
            await updateChecklistDefinition({
              definitionId: checklistId || '',
              body: formData,
            })
              .unwrap()
              .then(() => {
                if (blockerContext?.wasSubmittedFromBlocker) {
                  return;
                }
                navigate(settingsRoutes.generalChecklist);
              })
              .catch((e: ApiError) =>
                handleApiError(e, {signalApiError: blockerContext?.reportApiFailure})
              );
          }}
          isLoading={updateChecklistDefinitionQuery.isLoading}
          isEditing
        />
      </SettingsTemplate>
    </DataStatus>
  );
}
